import axios from 'axios'

const adminApi = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_SERVICE_URL || '/api/admin',
  withCredentials: true,
  timeout: Number(import.meta.env.VITE_API_TIMEOUT_MS || 5000),
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor — attach the ADMIN access token (issued by POST /admin/auth/login,
// stored by userStore as `adminAccessToken`). Previously this wrongly sent the main-app
// user token (getToken()), which admin-service always rejected (401). (N1)
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminAccessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

adminApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status
    const isAuthRequest = error.config?.url?.includes('/admin/login') || error.config?.url?.includes('/admin/profile')
    
    if ((status === 401 || status === 403) && !error.config?.skipAdminRedirect && !isAuthRequest) {
      localStorage.removeItem('adminAccessToken')
      localStorage.removeItem('adminRefreshToken')
      localStorage.removeItem('adminUser')
      
      const path = window.location.pathname.replace(/\/$/, '')
      console.warn(`[AdminAPI] ${status} at ${error.config?.url}. Current path: ${path}`)
      
      if (path !== '/admin-login') {
        console.log('[AdminAPI] Redirecting to /admin-login')
        window.location.href = '/admin-login'
      }
    }
    return Promise.reject(error)
  }
)

export default adminApi
